import React from "react";
import PropTypes from "prop-types";
import { Route, Redirect } from "react-router";
import moment from "moment";

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      let tokenExpirationDate =
        localStorage.getItem("tokenExpirationDate") || moment();

      if (moment(tokenExpirationDate).isSameOrBefore(moment())) {
        localStorage.removeItem("credentials");
        localStorage.removeItem("tokenExpirationDate");
      }

      return localStorage.getItem("credentials") ? (
        <Component {...props} />
      ) : (
        <Redirect to={`/login?url_redirect=${props.match.url}`} />
      );
    }}
  />
);

PrivateRoute.propTypes = {
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  match: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }),
};

export default PrivateRoute;



// WEBPACK FOOTER //
// ./src/helpers/PrivateRoute.js